export default __webpack_public_path__ + "static/media/advertising.a7b196eb.png";